'use client';

import { useSearch } from '@/app/search-context';
import { EMPTY_MEASUREMENTS } from './actions/list';

export default function MeasurementClearClient({ label, className, }: { label: string, className?: string }) {
  const { measurementFilters, clearMeasurementFilters, } = useSearch();

  const isActive = Object.keys(EMPTY_MEASUREMENTS).some(
    k => measurementFilters[k as keyof typeof measurementFilters] != null
  );

  return (
    <button
      type="button"
      className={`filter-clear ${isActive ? `filter-clear-active` : ``} ${className ?? ``}`}
      disabled={!isActive}
      onClick={clearMeasurementFilters}
    >
      {label}
    </button>
  );
}
